<template>
  <v-dialog v-model="visible" max-width="641" persistent>
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">
          {{ $t(`${namespace}.deleteChargebackOnRace`) }} #{{ data.ride.detail.apiInfo.apiTaxiJobId }}
        </span>

        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          :disabled="isLoading"
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text
        v-if="isValidObject(data)"
        class="px-4 pt-0 pb-5"
        v-html="
          $t(`${namespace}.deleteRideCreditMessage`)
            .replace('[CREDIT_VALUE]', `<strong>${convertToCurrencyBRL(data.credit.value)}</strong>`)
            .replace('[CREDIT_RIDE_ID]', `<strong>${data.ride.detail.apiInfo.apiTaxiJobId}</strong>`)
        "
      />

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer/>

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close(null)"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :loading="isLoading"
          :disabled="isLoading"
          color="accent"
          depressed
          round
          @click.native="cancelCredit"
        >
          {{ $t('Common.proceed') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { isObject, convertToCurrencyBRL } from 'utils/functions'

export default {
  name: 'DeleteCreditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.FinancialAdjustmentsPage',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    convertToCurrencyBRL (val) {
      return convertToCurrencyBRL(val)
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async cancelCredit () {
      this.isLoading = true

      try {
        const message = this.$t(`${this.namespace}.deleteRideCreditSuccess`)
          .replace('[CREDIT_VALUE]', convertToCurrencyBRL(this.data.credit.value))
          .replace('[CREDIT_RIDE_ID]', this.data.ride.detail.apiInfo.apiTaxiJobId)

        const creditId = this.data.credit.id

        const { data: res } = await this.$apiService.cancelCredit(creditId)

        if (res && !res.valid) {
          const error = this.isValidArray(res.reasons) ? res.reasons[0] : res.message
          this.showAlert({
            type: 'error',
            message: error || this.$t(`${this.namespace}.deleteRideCreditError`)
          })
        } else {
          this.showAlert({ type: 'success', message })
          this.close(true)
        }
      } catch (error) {
        console.log('ERROR:', error)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.deleteRideCreditError`)
        })
      }

      this.isLoading = false
    }
  }
}
</script>
